/**
 * Интерфейс постоянной микс-шины синхронного аудио для внешних систем
 * обработки голоса (эквалайзер/громкость микрофона в настройках конференции).
 *
 * Пока шина не установлена, все методы — безопасные заглушки, поэтому
 * вызывать их можно без проверок из любого состояния.
 *
 * Провайдер (audio-controls-provider) подменяет реализации при установке
 * и сбрасывает на заглушки при снятии шины.
 */
export const syncMixBus = {
  /** Жива ли шина (микс опубликован). */
  isActive: () => false,
  /**
   * Заменить голосовой трек в миксе (например, на выход EQ-цепочки).
   * На захват/публикацию не влияет — переключается только источник в шине.
   */
  setVoiceTrack: () => {},
  /**
   * Громкость голоса в миксе, 0..1. Применяется гейном в живом контексте
   * шины (не в EQ-цепочке) — надёжно во всех браузерах, мгновенно.
   * Вызывается из настроек конференции при движении ползунка микрофона.
   */
  setVoiceVolume: () => {},
  /** Сырой (необработанный) LocalAudioTrack микрофона ведущего, если есть. */
  getRawVoiceTrack: () => null,
};
